module.exports = __webpack_public_path__ + "img/yfc-thumb4.5f3e41ec.png";